import script from "./PIDJourneyEventPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PIDJourneyEventPanel.vue?vue&type=script&setup=true&lang=js"

import "./PIDJourneyEventPanel.vue?vue&type=style&index=0&id=780c23b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-780c23b0"]])

export default __exports__